export enum DynamicYieldEventType {
  ADD_TO_WISHLIST = 'add-to-wishlist-v1',
  FILTER_ITEMS = 'filter-items-v1',
  CLEAR_FILTERS = 'clear-filters',
  IDENTIFY_API = 'he',
  KEYWORD_SEARCH = 'keyword-search-v1',
  SORT_ITEMS = 'sort-items-v1',
  LOGIN = 'login-v1',
  MESSAGE_OPT_IN = 'message-optin-v1',
  MESSAGE_OPT_OUT = 'message-optout-v1',
  NEWSLETTER_SUBSCRIPTION = 'newsletter-subscription-v1',
}

export enum CustomDynamicYieldEventType {
  REMOVE_NUM_FACET = 'Remove numeric facet filter',
  REMOVE_STRING_FACET = 'Remove string facet filter',
  CLICKOUT = 'frontend_clickout',
}

export interface DynamicYieldSortData {
  sortBy: 'PRICE' | 'AGE' | 'POPULARITY' | 'OTHER';
  sortOrder: 'ASC' | 'DESC';
}

export enum DynamicYieldPageType {
  HOMEPAGE = 'HOMEPAGE',
  CATEGORY = 'CATEGORY',
  PRODUCT_PAGE = 'PRODUCT',
  OTHER = 'OTHER',
}

export interface DynamicYieldPageContext {
  type: DynamicYieldPageType;
  data?: string[];
}
